import { css } from '@emotion/react';
import { color, spacing, typography } from '@uniquegood/realworld-studio-design';

interface PurposeTextareaProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  maxLength?: number;
}

export default function PurposeTextarea({
  value,
  onChange,
  placeholder = '채널 사용 목적을 간단히 입력해 주세요.',
  maxLength = 200
}: PurposeTextareaProps) {
  return (
    <div css={container}>
      <textarea
        css={textareaStyle}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        maxLength={maxLength}
        rows={4}
        style={{
          padding: '8px 12px'
        }}
      />
    </div>
  );
}

const container = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing.common.small + 4}px;
  width: 100%;
  border-radius: 4px;
`;

const textareaStyle = css`
  width: 100%;
  min-height: 80px;
  padding: ${spacing.common.small}px ${spacing.common.small + 4}px;
  border: 1px solid ${color.border_default_subdued};
  border-radius: 4px;
  background: ${color.surface_default_subdued};
  resize: vertical;

  color: ${color.text_default};
  font-family: ${typography.family.primary};
  font-size: ${typography.size.s2};
  font-weight: ${typography.weight.regular};
  line-height: 20px;

  outline: none;

  &:focus {
    outline: 1px solid ${color.palette_primary_purple_100};
    background: ${color.surface_default_default};
  }

  &::placeholder {
    color: ${color.text_disabled};
  }
`;
